package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_10_11_Day_1
import com.veldekar.components.logs.Log_2024_10_11_Day_2
import com.veldekar.components.logs.Log_2024_10_11_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-10-11")
@Composable
public fun Log_2024_10_11(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Brij Bridge Journey",
        ogTitle = "Brij Bridge Journey",
        date = LocalDate(2_024, 10, 11),
        ogDescription = "The party chases an escape artist and travels toward the Brij Bridge, facing Ankhegs in the badlands.",
        ogImage = "ai/2024-10-11.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-57", dateString = "Newgrowth 57")
        Log_2024_10_11_Day_1()
        SessionDayHeader(dayId = "newgrowth-58", dateString = "Newgrowth 58", cardImageSrc = "images/MalusToBrijBridge.webp", width = 876, height = 574)
        Log_2024_10_11_Day_2()
        SessionDayHeader(dayId = "newgrowth-63", dateString = "Newgrowth 63")
        Log_2024_10_11_Day_3()
    }
}
